(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vow-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const target=event.target.closest('[data-vow-demo]');if(!target)return;const dialog=target.closest('.vow-page').querySelector('.vow-dialog');if(dialog&&!dialog.open)dialog.showModal();});

  } catch(e) { console.error(e); }
})();
})();
